import { useTranslation } from "react-i18next";
import { GoogleDocsTerms } from "../../components/common/GoogleDocsTerms";

export const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return <GoogleDocsTerms type="privacy" title={t("privacy_policy")} />;
};
